/**
 * Píxel de Meta "Perro Obediente" (el mismo que usa el checkout de Impultienda).
 * En la landing manda PageView y ViewContent. InitiateCheckout y Purchase los manda el checkout,
 * así que acá no se repiten.
 */
const PIXEL_ID = "2669910076762780";

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: unknown;
  loaded: boolean;
  version: string;
};

export function initMetaPixel(): void {
  const w = window as unknown as { fbq?: Fbq; _fbq?: Fbq };
  if (w.fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  w.fbq = n;
  w._fbq = n;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  n("init", PIXEL_ID);
  n("track", "PageView");
  n("track", "ViewContent", {
    content_name: "Reconecta con tu mascota - Colección completa",
    content_type: "product",
  });
}
